import {
    Box,
    Button,
    Flex,
    HStack,
    IconButton,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Select,
    Spacer,
    Stack,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useDisclosure,
    useToast
} from "@chakra-ui/react";
import React from "react";
import { MdAdd, MdArrowDropDown, MdMoreHoriz, MdPlusOne } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { EventForm } from "../../forms";
import {
    Event_Epoch,
    GetEventsDocument,
    useCreateEventMutation,
    useGetEventsNotUserScopedQuery
} from "../../graphql";
import { formatDateTime } from "../../utils";

const EventsPage: React.FC = () => {
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const history = useHistory();

    const [createEvent] = useCreateEventMutation();
    const { data, loading, refetch } = useGetEventsNotUserScopedQuery();

    // refetch({
    //   epoch: ""
    // })

    const onEventCreate = async (values) => {
        const { data } = await createEvent({
            variables: {
                coverMediaKey: values.cover.key,
                description: values.description,
                durationMinutes: parseInt(values.durationMinutes),
                maxParticipantsNumber: parseInt(values.maxParticipantsNumber),
                specialistId: parseInt(values.specialistId),
                startDate: `${values.startDate}:00Z`,
                title: values.title
            },
            refetchQueries: [{ query: GetEventsDocument }]
        });

        onClose();

        toast({
            title: "Sukses",
            description: "Vizita u shtua",
            status: "success",
            isClosable: true
        });

        history.push(`/event/${data.createEvent.id}`);
    };

    return (
        <>
            <Modal
                closeOnOverlayClick={ false }
                isOpen={ isOpen }
                onClose={ onClose }
                size="lg"
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Shto një event</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <EventForm onSubmit={ onEventCreate } />
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Box
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                p={ 2 }
                background="white"
            >
                <>
                    <Title title="Lista e eventeve">
                        <HStack p={ 3 }>
                            <Stack>
                                <Text fontSize="xs" p={ 0 } m={ 0 } lineHeight={ 0.2 }>
                                    Sipas periudhës
                                </Text>
                                <Select
                                    icon={ <MdArrowDropDown /> }
                                    size="sm"
                                    onChange={ (event) => {
                                        refetch({
                                            epoch: event.target.value as Event_Epoch
                                        });
                                    } }
                                >
                                    <option value="UPCOMING">Do të zhvillohen</option>
                                    <option value="PAST">Të kaluara</option>
                                </Select>
                            </Stack>

                            <Stack>
                                <Text fontSize="xs" p={ 0 } m={ 0 } lineHeight={ 0.2 }></Text>
                                <Button
                                    leftIcon={ <MdAdd /> }
                                    colorScheme="blue"
                                    size="sm"
                                    variant="ghost"
                                    onClick={ onOpen }
                                >
                                    Shto
                                </Button>
                            </Stack>
                        </HStack>
                    </Title>

                    { loading ? (
                        <Loader />
                    ) : (
                        <Table variant="striped" size="sm">
                            <Thead>
                                <Tr>
                                    <Th>Mjeku Organizator</Th>
                                    <Th>Titulli</Th>
                                    <Th isNumeric>Pjesëmarrës</Th>
                                    <Th isNumeric>Data</Th>
                                    <Th isNumeric>Kohëzgjatja</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                { data.getEventsNotUserScoped.map((event) => (
                                    <Tr key={ event.id }>
                                        <Td>
                                            <Link to={ `/event/${event.id}` }>
                                                <AccountAvatar
                                                    account={ event.specialist }
                                                    role={ false }
                                                    size="xs"
                                                />
                                            </Link>
                                        </Td>
                                        <Td>{ event.title }</Td>
                                        <Td isNumeric>
                                            { event.participants.list.length } /
                                            { event.participants.maxNumber }
                                        </Td>
                                        <Td isNumeric>{ formatDateTime(event.startDate) }</Td>
                                        <Td isNumeric>{ event.durationMinutes } minuta</Td>
                                    </Tr>
                                )) }
                            </Tbody>
                        </Table>
                    ) }
                </>
            </Box>
        </>
    );
};

export default EventsPage;
